"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBoxTabItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function InfoBoxTabItemBase(_a) {
    var { icon, label, index: _index, forwardedRef, style, stub, selected, className, focusable = true } = _a, 
    /**
     * Propagate event press handlers
     */
    rest = __rest(_a, ["icon", "label", "index", "forwardedRef", "style", "stub", "selected", "className", "focusable"]);
    const getStyle = (0, react_1.useCallback)(() => {
        if (!style) {
            return {};
        }
        return Object.assign(Object.assign({}, style), { zIndex: 1 });
    }, [style]);
    const a11yProps = focusable
        ? {
            'aria-roledescription': 'draggable',
        }
        : {
            tabIndex: -1,
        };
    return ((0, jsx_runtime_1.jsxs)(Container, Object.assign({ as: focusable ? 'button' : 'div', ref: forwardedRef, style: getStyle(), className: className, "$selected": selected, "$focusable": focusable, "$stub": stub }, a11yProps, rest, { "data-e2e": 'InfoBoxTabItemBase_Container', children: [!stub && (0, jsx_runtime_1.jsx)(StyledIcon, { name: icon, "data-e2e": 'InfoBoxTabItemBase_StyledIcon' }), !stub && (0, jsx_runtime_1.jsx)(Label, { "data-e2e": 'InfoBoxTabItemBase_Label', children: label })] })));
}
const WithA11y = (0, ui_1.withA11y)(InfoBoxTabItemBase);
exports.InfoBoxTabItem = (0, react_1.forwardRef)((props, ref) => (0, jsx_runtime_1.jsx)(WithA11y, Object.assign({ forwardedRef: ref }, props, { "data-e2e": 'WithA11y' })));
const Container = styled_components_1.default.button `
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 80px;
  height: 80px;

  color: ${({ theme }) => theme.designSystem.text};
  font-size: 10px;
  line-height: 1em;
  text-align: center;

  background: ${({ theme }) => theme.designSystem.contentBackground};
  border: 2px solid ${({ theme }) => theme.designSystem.background};
  border-radius: 4px;

  outline-width: 1px;
  outline-offset: -2px;

  cursor: pointer;

  user-select: none;

  ${({ $selected }) => $selected &&
    (0, styled_components_1.css) `
      border-color: ${({ theme }) => theme.designSystem.highlightedBorder};

      background: ${({ theme }) => theme.designSystem.highlightedBackground};
    `}

  ${({ $focusable }) => !$focusable &&
    (0, styled_components_1.css) `
      cursor: initial;
      outline: none;
    `}

  ${({ $stub }) => $stub &&
    (0, styled_components_1.css) `
      background: none;

      border: 1px dashed ${({ theme }) => theme.settings.text};
      border-radius: 0;
    `}
`;
const Label = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;

  pointer-events: none;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  max-width: 74px;
  height: 32px;
  margin: 12px 0 0;

  pointer-events: none;
`;
